import { FC } from 'react'

interface IProps {
  handleNieuw: (isdefault: boolean) => void
}

const ActionButtons: FC<IProps> = ({ handleNieuw }) => {
  return (
    <>
      <button className='btn btn-primary' onClick={e => handleNieuw(false)}>
        Toevoegen Tijdvak
      </button>
      <button
        className='btn btn-secondary ml-4'
        onClick={e => handleNieuw(true)}
      >
        Toevoegen Default Tijdvak
      </button>
    </>
  )
}

export default ActionButtons
